import React from 'react';
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Bar,
  ReferenceLine,
} from 'recharts';
import { Box, Typography } from '@mui/material';
import { REPORTED_TIME_CHARTS_COLORS } from '../useReportedHoursService';
import { getProjectKeys, CustomizedYAxisLabel, CustomTooltip, CustomLegend } from './weeklyLoggedHelpers';
import { useShowContext } from 'framework/show';
import { WeeklyChartDataType } from '../types';

const WeeklyLoggedTimeChart = () => {
  const { data } = useShowContext();
  const { weeklyChartData } = data.getData();
  const keys = getProjectKeys(weeklyChartData as WeeklyChartDataType[]);

  return (
    <Box mb="30px">
      <Typography display="block" textAlign="center" mb="10px" variant="body1">
        Weekly Logged Time Distribution
      </Typography>

      <Box height="220px">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={weeklyChartData} margin={{ left: 0 }}>
            <CartesianGrid strokeDasharray="2 2" />
            <XAxis tick={{ fontSize: 12 }} dataKey="name" />
            <YAxis
              tick={{ fontSize: 12 }}
              domain={[0, 120]}
              ticks={[0, 20, 40, 60, 80, 100, 120]}
              label={<CustomizedYAxisLabel />}
            />
            <Tooltip wrapperStyle={{ fontSize: 12 }} content={<CustomTooltip />} />
            <Legend wrapperStyle={{ fontSize: 12 }} content={<CustomLegend />} />

            <ReferenceLine y={100} stroke="var(--mui-palette-neutral-main)" strokeDasharray="4 4" />

            {keys.map((key, i) => (
              <Bar
                key={key}
                dataKey={key}
                name={key}
                fillOpacity={0.9}
                stackId="a"
                fill={REPORTED_TIME_CHARTS_COLORS[i % REPORTED_TIME_CHARTS_COLORS.length]}
              />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};
export default WeeklyLoggedTimeChart;
